<template lang="html">
  <div class="mng-editor-content">
    <div class="mng-editor-panel"  v-show="errolabelVisible">
      <div class="mng-editor-panel__block">
        <div class="mng-editor-panel__label">
          错误日志
        </div>
        <div class="form-item__content">
          <el-input v-model="description"
                    type="textarea"
                    :autosize = "true"
                    placeholder="请输入不超过5行, 可在右侧预览效果" />
        </div>
        <button
          v-for="(item,index) in erroBtnData"
          :key="item.val"
          @click="showErroPage(index)">
          {{item.val}}
        </button>
      </div>
    </div>
    <div class="mng-editor-panel" v-show="labelVisible">
      <div class="mng-editor-panel__block">
        <div class="mng-editor-panel__label">
          模型标题
        </div>
        <el-input v-model="name"
                  @change="testChanged"
                  class="mng-editor-panel__input"
                  placeholder="请输入模型标题" />
      </div>
      <div class="mng-editor-panel__block">
        <div class="mng-editor-panel__label">
          店铺简介
        </div>
        <el-input v-model="description"
                  maxlength="10"
                  class="mng-editor-panel__input"
                  placeholder="请输入店铺简介(不超过10字)" />
      </div>
      <div class="mng-editor-panel__block">
        <div class="mng-editor-panel__label">
          所属商场
        </div>
        <el-select v-model="parentMallId"
                   class="mng-editor-panel__select"
                   placeholder="选择商场"
                   size="medium">
          <el-option
            v-for="item in mallList"
            :key="item.id"
            :label="item.mall_name"
            :value="item.id" />
        </el-select>
      </div>
      <div class="mng-editor-panel__block">
        <div class="mng-editor-panel__label">
          当前子图
        </div>
        <el-input v-model="ts1" disabled placeholder=""></el-input>
        </el-select>
      </div>
      <div class="mng-editor-panel__block">
        <div class="mng-editor-panel__label">
          对应底图
        </div>
        <el-input v-model="ts2" disabled placeholder=""></el-input>
        </el-select>
      </div>
      <a :href="vr_id_img" class="img_container" target="_blank" :downlond="vr_id">
        <img class="vr_img" :src="vr_id_img"/>
      </a>
       <a :href="imageurl" class="img_container" target="_blank" :downlond="vr_id">
        <img class="vr_img" :src="imageurl"/>
      </a>
      <!-- <div class="mng-editor-panel__block m:ng-editor-panel__block--last">
        <div class="mng-editor-panel__label">
          店铺LOGO
        </div>
        <div v-show="removeIcon" class="image-uploads__imageremove" @click="removeThumb">
          -
        </div>
        <AiImageUpload ref="uploader"
                       text="上传LOGO"
                       accept="image/*"
                       :image-url="logo"
                       :width="100"
                       draggable="false"
                       @change="onLogoImageChanged"
                       @filesize="onLogoImageSize"/>
      </div> -->

      <div class="ai-button ai-button--primary mng-editor-panel__button"
           @click="updateInfo">
        保存所有设置
      </div>
    </div>
    <div class="mng-vr-scene" v-show="labelVisible">
      <!-- <VrScene class="mng-vr-scene__stage" :scene-id="$route.params.modelId" /> -->
      <VrScene :sceneId="$route.params.modelId"/>
    </div>
    <div v-show="errolabelVisible" >
      <iframe v-show="errolabelVisible"
              id="show-iframe"
              width="900"
              height="100%"
              frameborder=0
              name="showHere"
              scrolling=auto
              :src="erroMsg">
      </iframe>
    </div>
  </div>
</template>

<script>
// import VrScene from '../../../components/ai-vr-scene.vue';
import VrScene from '@/components/owllySence/VrScene';

export default {
  components: {
    VrScene
  },
  watch: {
  },
  data() {
    return {
      labelVisible: true,
      errolabelVisible: false,
      parentMallId: null,
      mallList: [],
      description: '',
      name: '',
      ts1: '',
      ts2: '',
      vr_id: '',
      vr_id_img: '',
      logo: null,
      pendingLogo: '',
      erroMsg: '',
      removeIcon: false,
      erroMsglink: [],
      imageurl: null,
      erroBtnData: [
        {
          val: '查看日志1'
        }, {
          val: '查看日志2'
        }, {
          val: '查看日志3'
        }
      ]
    };
  },
  mounted() {
    this.getMallList();
    this.vr_id = this.$route.params.modelId;
    this.getImage()
    if (this.vr_id) {
      this.fetchTimeStamp();
      this.vr_id_img = `/mesh/image/${this.vr_id}.png`;
    }
  },
  methods: {
    fetchTimeStamp() {
      const promise = [
        `/admin/code2timestamp/${this.vr_id}`,
        `/admin/basemap/${this.vr_id}`].map(ele => {
          return fetch(ele);
        });
      Promise.all(promise).then(res => {
        res.forEach((ele, id) => {
          ele.text().then(resp => {
            this[`ts${id + 1}`] = resp;
          })
        })
      })
    },
    maxLength() {
      if (this.name.length > 10) {
        this.name = String(this.name).slice(0, 10);
      }
      if (this.description.length > 10) {
        this.description = String(this.description).slice(0, 10);
      }
    },
    validateTextLength(value) {
      //  中文、中文标点、全角字符按1长度，英文、英文符号、数字按0.5长度计算
      const cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/g;
      const mat = value.match(cnReg);
      let length;
      if (mat) {
        length = (mat.length + (value.length - mat.length) * 0.5);
        return length;
      }
      return value.length * 0.5;
    },
    removeThumb() {
      this.pendingLogo = null;
      this.$refs.uploader.clear();

    },
    testChanged() {
      //  console.log(this.name.indexOf('https:'));
      if (this.name.indexOf('https:') !== -1) {
        const gets = this.name.split('https')[0];
        this.name = String(gets);
        //  console.log(gets);
      }
    },
    async showErroPage(index) {
      this.erroMsg = String(this.erroMsglink[index]);
    },
    async getMallList() {
      try {
        const { data: { data } } = await this.$http.post(
          '/admin/list-malls?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          { store_id: this.$route.params.modelId }
        );
        this.mallList = data;
        this.getStoreInfo();
      } catch (error) {
        this.$log(error.error_msg);
      }
    },
    async getStoreInfo() {
      try {
        const { data: { data } } = await this.$http.post(
          '/admin/get-store-info?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          { store_id: this.$route.params.modelId }
        );
        this.description = data.description;
        this.name = data.store_name;
        this.parentMallId = data.parent_mall_id;
        this.logo = data.logo;
        if (this.name.indexOf('生成失败') !== -1) {
          this.labelVisible = false;
          this.errolabelVisible = true;
          this.erroMsglink = this.description.split(',');
          this.showErroPage(0);
        }
      } catch (error) {
        this.$log(error.error_msg);
      }
    },
    async updateInfo() {
      try {
        if (this.logosize > 2) {
          this.$message('图片尺寸大于2M,请重新选择');
          return;
        }
        const payload = {
          store_id: this.$route.params.modelId,
          store_name: this.name,
          description: this.description,
          parent_mall_id: this.parentMallId
        };
        if (this.pendingLogo) {
          payload.logo = this.pendingLogo.replace(/data:image.*?,/gi, '');
        }
        await this.$http.post(
          '/admin/modify-store-info?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          payload
        );
        this.$message('修改成功');
      } catch (error) {
        console.log('updateInfo  ---- ', error);
        this.$log(error.error_msg);
      }
    },
    onLogoImageChanged(src) {
      this.pendingLogo = src;
      if (src)
        this.removeIcon = true;
      else this.removeIcon = false;
    },
    onLogoImageSize(size) {
      this.logosize = size / Math.pow(1024, 2);
      if (this.logosize > 2) {
        this.$message('图片尺寸大于2M,请重新选择');
      }
      //  console.log('this.logosize:',this.logosize);
    },
    async getImage() {
      try {
        let res = await fetch(`/admin/xray/${this.$route.params.modelId}`).then(res => res.text())
        this.imageurl = res
        console.log('res', this.imageurl)
      } catch (error) {
        this.imageurl = error
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.image-uploads {
  display: flex;
  justify-content: space-between;
  padding: 0 27px;

  &__text {
    color: #666;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    user-select: none;

    &--sub {
      font-size: 8px;
    }
  }

  &__imageremove {
    position: absolute;
    margin-top: 5px;
    margin-left: 85px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: #f50;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    cursor: pointer;
    user-select: none;
  }
}
.img_container {
  display: block;
}
.vr_img {
  width: 300px;
}
</style>
